//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const consola = require('consola'); consola.level = process.env.CONSOLA_LEVEL;
// import { mapGetters, mapMutations, mapActions } from 'vuex'
// import DatePick from 'vue-date-pick'
// import 'vue-date-pick/dist/vueDatePick.css'


export default {
	// name: 'rest-date',
	components:
	{
		// 'vue-date-pick': DatePick,
		// Popover
	},

	props:
	{
		placement:
		{
			type: String,
			default: 'left'
		},

		editable:
		{
			type: Boolean,
			default: false
		},

		timestamp:
		{
			required: true
		},

		// tag:
		// {
		// 	type: String,
		// 	default: 'span'
		// },

		url:
		{
			type: String,
			default: 'date'
		},

		field:
		{
			type: String,
			default: ''
		},

		modelId:
		{
			type: Number,
			default: -1,
		},

		allowCreate:
		{
			type: Boolean,
			default: false,
		},

		extraField:
		{
			type: String,
			default: 'course_id',
		},

		extraValue:
		{
			default: null,
		},

		delete:
		{
			type: Boolean,
			default: false,
		},
	},

	data()
	{
		return {
			date: null,
			dateModel: '',
		}
	},

	computed:
	{
		// ...mapGetters(['isEditingPage', 'lang', 'langShort',]),
		isUnixDate() {	return !((this.timestamp+'').indexOf(':') > -1)	}
	},

	watch:
	{

	},

	created()
	{
		if ( this.isUnixDate )
			this.date = new Date( parseInt(this.timestamp) )
		else
			this.date = new Date( this.timestamp )

		if (!this.timestamp || !this.date)
		{
			// debugger
		}
		consola.debug('date: ', this.date)
	},


}
